<template>
  <el-dialog
    title="回复评价"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form :model="form" label-width="100px">
      <el-form-item label="评价内容">
        <div style="padding: 10px; background-color: #f5f7fa; border-radius: 4px; margin-bottom: 10px;">
          {{ appraise.context }}
        </div>
      </el-form-item>
      <el-form-item label="回复内容" required>
        <el-input
          v-model="form.context"
          type="textarea"
          :rows="4"
          placeholder="请输入回复内容"
          maxlength="512"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="_submitReply" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ackAppraise } from '@/api/goods/productDetailApi'

export default {
  name: 'AckAppraise',
  props: {
    shopId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      appraise: {},
      form: {
        context: ''
      }
    }
  },
  methods: {
    open(appraise) {
      this.appraise = appraise || {}
      this.form.context = ''
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.form.context = ''
      this.appraise = {}
    },
    async _submitReply() {
      if (!this.form.context || !this.form.context.trim()) {
        this.$message.warning('请输入回复内容')
        return
      }

      if (this.form.context.trim().length > 512) {
        this.$message.warning('回复内容不能超过512个字符')
        return
      }

      this.submitting = true
      try {
        const params = {
          parentAppraiseId: this.appraise.appraiseId,
          context: this.form.context.trim(),
          shopId: this.shopId
        }
        const res = await ackAppraise(params)
        if (res.code === 0 || res.code === '0') {
          this.$message.success(res.msg || '回复成功')
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '回复失败')
        }
      } catch (error) {
        console.error('回复失败:', error)
        this.$message.error(error.message || error || '回复失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
</style>

